// extracted by mini-css-extract-plugin
export default {"container":"Item_container__DTbC0"};